import { MessageType, PbLong, typeofJsonValue, reflectionMergePartial, UnknownFieldHandler, WireType, jsonWriteOptions, isJsonObject, base64encode, base64decode } from '@protobuf-ts/runtime';
import { makeAutoObservable } from 'mobx';
import { format, differenceInMilliseconds } from 'date-fns';
import loglevel from 'loglevel';
import { RpcError, mergeRpcOptions, Deferred, RpcOutputStreamController, ServerStreamingCall, UnaryCall } from '@protobuf-ts/runtime-rpc';
import { Base64 } from 'js-base64';
import { noop, isNil } from 'lodash-es';
import mitt from 'mitt';
import { clearTimeout, setTimeout, setInterval, clearInterval } from 'worker-timers';

var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["CodeOK"] = 0] = "CodeOK";
  ErrorCode2[ErrorCode2["NoContent"] = 15] = "NoContent";
  ErrorCode2[ErrorCode2["BadRequest"] = 3] = "BadRequest";
  ErrorCode2[ErrorCode2["Unauthorized"] = 16] = "Unauthorized";
  ErrorCode2[ErrorCode2["MethodNotAllowed"] = 7] = "MethodNotAllowed";
  ErrorCode2[ErrorCode2["Internal"] = 13] = "Internal";
  ErrorCode2[ErrorCode2["Unknown"] = 2] = "Unknown";
  ErrorCode2[ErrorCode2["RequestTimeout"] = 50] = "RequestTimeout";
  ErrorCode2[ErrorCode2["RouterException"] = 51] = "RouterException";
  ErrorCode2[ErrorCode2["StatusFound"] = 52] = "StatusFound";
  ErrorCode2[ErrorCode2["InsufficientResources"] = 53] = "InsufficientResources";
  ErrorCode2[ErrorCode2["EOF"] = 54] = "EOF";
  ErrorCode2[ErrorCode2["AsyncReturn"] = 55] = "AsyncReturn";
  ErrorCode2[ErrorCode2["InternalServerError"] = 56] = "InternalServerError";
  ErrorCode2[ErrorCode2["ServiceNotFound"] = 57] = "ServiceNotFound";
  ErrorCode2[ErrorCode2["MethodNotFound"] = 58] = "MethodNotFound";
  ErrorCode2[ErrorCode2["NetworkException"] = 59] = "NetworkException";
  ErrorCode2[ErrorCode2["ServiceUnavailable"] = 60] = "ServiceUnavailable";
  ErrorCode2[ErrorCode2["QueueNotFound"] = 61] = "QueueNotFound";
  ErrorCode2[ErrorCode2["Max"] = 1e3] = "Max";
  ErrorCode2[ErrorCode2["CodeNotLogin"] = 2e3] = "CodeNotLogin";
  ErrorCode2[ErrorCode2["CodeRepeated"] = 2001] = "CodeRepeated";
  ErrorCode2[ErrorCode2["CodeConfNotExist"] = 3e3] = "CodeConfNotExist";
  ErrorCode2[ErrorCode2["CodeInvalidConf"] = 3001] = "CodeInvalidConf";
  ErrorCode2[ErrorCode2["CodeUserUpdateResultNicknameDuplicate"] = 3101] = "CodeUserUpdateResultNicknameDuplicate";
  ErrorCode2[ErrorCode2["CodeUserUpdateResultNicknameChanceLimit"] = 3102] = "CodeUserUpdateResultNicknameChanceLimit";
  ErrorCode2[ErrorCode2["CodeUserUpdateResultNicknameInvalid"] = 3103] = "CodeUserUpdateResultNicknameInvalid";
  ErrorCode2[ErrorCode2["CodeUserUpdateResultNicknameLenInvalid"] = 3104] = "CodeUserUpdateResultNicknameLenInvalid";
  ErrorCode2[ErrorCode2["CodeUserUpdateResultNicknameDisableUpdate"] = 3105] = "CodeUserUpdateResultNicknameDisableUpdate";
  ErrorCode2[ErrorCode2["CodeMatchNotExist"] = 4e3] = "CodeMatchNotExist";
  ErrorCode2[ErrorCode2["CodeAssetNotEnough"] = 4001] = "CodeAssetNotEnough";
  ErrorCode2[ErrorCode2["CodeDuplicatedRegistration"] = 4002] = "CodeDuplicatedRegistration";
  ErrorCode2[ErrorCode2["CodeMatchStarted"] = 4003] = "CodeMatchStarted";
  ErrorCode2[ErrorCode2["CodeMatchFinish"] = 4004] = "CodeMatchFinish";
  ErrorCode2[ErrorCode2["CodeLateRegisterExpired"] = 4005] = "CodeLateRegisterExpired";
  ErrorCode2[ErrorCode2["CodeSameSessionMatchExist"] = 4006] = "CodeSameSessionMatchExist";
  ErrorCode2[ErrorCode2["CodeMatchUserFull"] = 4007] = "CodeMatchUserFull";
  ErrorCode2[ErrorCode2["CodeConfigNotEnable"] = 4008] = "CodeConfigNotEnable";
  ErrorCode2[ErrorCode2["CodeNotRegister"] = 4009] = "CodeNotRegister";
  ErrorCode2[ErrorCode2["CodeReachMaxRebuy"] = 4010] = "CodeReachMaxRebuy";
  ErrorCode2[ErrorCode2["CodeMatchInFinal"] = 4011] = "CodeMatchInFinal";
  ErrorCode2[ErrorCode2["CodeBlindLevelMisMatch"] = 4012] = "CodeBlindLevelMisMatch";
  ErrorCode2[ErrorCode2["CodeTableSeatOccupied"] = 4013] = "CodeTableSeatOccupied";
  ErrorCode2[ErrorCode2["CodeTableSeatNotExist"] = 4014] = "CodeTableSeatNotExist";
  ErrorCode2[ErrorCode2["CodeTableNotFindUser"] = 4015] = "CodeTableNotFindUser";
  ErrorCode2[ErrorCode2["CodeMatchNotStart"] = 4016] = "CodeMatchNotStart";
  ErrorCode2[ErrorCode2["CodeBubbleTime"] = 4017] = "CodeBubbleTime";
  ErrorCode2[ErrorCode2["CodeEnterPrize"] = 4018] = "CodeEnterPrize";
  ErrorCode2[ErrorCode2["CodeExceedLimit"] = 4019] = "CodeExceedLimit";
  ErrorCode2[ErrorCode2["CodeNotInValidTimeRange"] = 4020] = "CodeNotInValidTimeRange";
  ErrorCode2[ErrorCode2["CodeChipsNotMatch"] = 4021] = "CodeChipsNotMatch";
  ErrorCode2[ErrorCode2["CodeCanceled"] = 4022] = "CodeCanceled";
  ErrorCode2[ErrorCode2["CodeMatchNeedApply"] = 4024] = "CodeMatchNeedApply";
  ErrorCode2[ErrorCode2["CodeTransactionOnGoing"] = 4025] = "CodeTransactionOnGoing";
  ErrorCode2[ErrorCode2["CodeNotOut"] = 4026] = "CodeNotOut";
  ErrorCode2[ErrorCode2["CodeTableNotExist"] = 4027] = "CodeTableNotExist";
  ErrorCode2[ErrorCode2["CodeMatchCanceled"] = 4028] = "CodeMatchCanceled";
  ErrorCode2[ErrorCode2["CodeMatchStopped"] = 4029] = "CodeMatchStopped";
  ErrorCode2[ErrorCode2["CodeMatchApplyRejected"] = 4030] = "CodeMatchApplyRejected";
  ErrorCode2[ErrorCode2["CodeNotOwner"] = 4031] = "CodeNotOwner";
  ErrorCode2[ErrorCode2["CodeUserNotEnough"] = 4032] = "CodeUserNotEnough";
  ErrorCode2[ErrorCode2["CodeInvalidTicket"] = 4033] = "CodeInvalidTicket";
  ErrorCode2[ErrorCode2["CodeTicketExpired"] = 4034] = "CodeTicketExpired";
  ErrorCode2[ErrorCode2["CodeUserIsOut"] = 4035] = "CodeUserIsOut";
  ErrorCode2[ErrorCode2["CodeInvalidMatchStatus"] = 4036] = "CodeInvalidMatchStatus";
  ErrorCode2[ErrorCode2["CodeNotPrizeUser"] = 4037] = "CodeNotPrizeUser";
  ErrorCode2[ErrorCode2["CodeInvalidForm"] = 4038] = "CodeInvalidForm";
  ErrorCode2[ErrorCode2["CodeInvalidRegisterNotEnoughVIPLeavel"] = 4039] = "CodeInvalidRegisterNotEnoughVIPLeavel";
  ErrorCode2[ErrorCode2["CodeInvalidRegisterNotIdentityLevel"] = 4040] = "CodeInvalidRegisterNotIdentityLevel";
  ErrorCode2[ErrorCode2["CodeTxProcessed"] = 4041] = "CodeTxProcessed";
  ErrorCode2[ErrorCode2["CodeTxInvalid"] = 4042] = "CodeTxInvalid";
  ErrorCode2[ErrorCode2["CodeMatchOver"] = 4043] = "CodeMatchOver";
  ErrorCode2[ErrorCode2["CodeMatchBusy"] = 4044] = "CodeMatchBusy";
  ErrorCode2[ErrorCode2["CodeUserNotInClub"] = 4045] = "CodeUserNotInClub";
  ErrorCode2[ErrorCode2["CodeNoPaymentInfo"] = 5001] = "CodeNoPaymentInfo";
  ErrorCode2[ErrorCode2["CodeInvalidMail"] = 5002] = "CodeInvalidMail";
  ErrorCode2[ErrorCode2["CodeReBuyLimit"] = 6001] = "CodeReBuyLimit";
  ErrorCode2[ErrorCode2["CodeNoMoney"] = 6002] = "CodeNoMoney";
  ErrorCode2[ErrorCode2["CodeAlreadyInSeat"] = 6003] = "CodeAlreadyInSeat";
  ErrorCode2[ErrorCode2["CodeAlreadyReward"] = 8001] = "CodeAlreadyReward";
  ErrorCode2[ErrorCode2["CodeCurrentNoAvailableTable"] = 1000002] = "CodeCurrentNoAvailableTable";
  ErrorCode2[ErrorCode2["CodeNotReachReceiveTime"] = 1000001] = "CodeNotReachReceiveTime";
  ErrorCode2[ErrorCode2["CODE_TABLE_NOT_FOUND"] = 483329] = "CODE_TABLE_NOT_FOUND";
  ErrorCode2[ErrorCode2["CODE_USER_NOT_FOUND"] = 483330] = "CODE_USER_NOT_FOUND";
  ErrorCode2[ErrorCode2["CODE_GAME_LOG_NOT_FOUND"] = 483331] = "CODE_GAME_LOG_NOT_FOUND";
  ErrorCode2[ErrorCode2["CODE_GAME_REPLAY_NOT_FOUND"] = 483332] = "CODE_GAME_REPLAY_NOT_FOUND";
  ErrorCode2[ErrorCode2["CODE_OBSERVE_TABLE_END"] = 483333] = "CODE_OBSERVE_TABLE_END";
  ErrorCode2[ErrorCode2["CODE_TABLE_ALREADY_START"] = 483334] = "CODE_TABLE_ALREADY_START";
  ErrorCode2[ErrorCode2["CODE_TABLE_OVERFLOW"] = 483335] = "CODE_TABLE_OVERFLOW";
  ErrorCode2[ErrorCode2["CODE_TABLE_NOT_FOUND_USER"] = 483336] = "CODE_TABLE_NOT_FOUND_USER";
  ErrorCode2[ErrorCode2["CodeNoEnoughPropNum"] = 700673] = "CodeNoEnoughPropNum";
  ErrorCode2[ErrorCode2["CodeTableViewReachLimit"] = 700674] = "CodeTableViewReachLimit";
  ErrorCode2[ErrorCode2["CodeTableViewExist"] = 700675] = "CodeTableViewExist";
  ErrorCode2[ErrorCode2["CodeUserNotOperating"] = 700676] = "CodeUserNotOperating";
  ErrorCode2[ErrorCode2["CodeUserTimeCardNotEnough"] = 700677] = "CodeUserTimeCardNotEnough";
  ErrorCode2[ErrorCode2["CodeCreateMailBusinessIdExist"] = 8e3] = "CodeCreateMailBusinessIdExist";
  ErrorCode2[ErrorCode2["PricesError"] = 9e3] = "PricesError";
  ErrorCode2[ErrorCode2["PropNotFound"] = 9001] = "PropNotFound";
  ErrorCode2[ErrorCode2["CoinNotFound"] = 9002] = "CoinNotFound";
  ErrorCode2[ErrorCode2["ProductExist"] = 9003] = "ProductExist";
  ErrorCode2[ErrorCode2["PrimitiveObjectID"] = 9004] = "PrimitiveObjectID";
  ErrorCode2[ErrorCode2["OnShelvesFail"] = 9005] = "OnShelvesFail";
  ErrorCode2[ErrorCode2["OffShelvesFail"] = 9006] = "OffShelvesFail";
  ErrorCode2[ErrorCode2["DelProductFail"] = 9007] = "DelProductFail";
  ErrorCode2[ErrorCode2["SetPinFail"] = 9008] = "SetPinFail";
  ErrorCode2[ErrorCode2["UnsetPinFail"] = 9009] = "UnsetPinFail";
  ErrorCode2[ErrorCode2["PropTypeInvalid"] = 9010] = "PropTypeInvalid";
  ErrorCode2[ErrorCode2["ClubNameExistError"] = 10001] = "ClubNameExistError";
  ErrorCode2[ErrorCode2["ClubMemberAddError"] = 10002] = "ClubMemberAddError";
  ErrorCode2[ErrorCode2["ClubMemberUpdateError"] = 10003] = "ClubMemberUpdateError";
  ErrorCode2[ErrorCode2["ClubMemberJoinError"] = 10004] = "ClubMemberJoinError";
  ErrorCode2[ErrorCode2["ClubLogoEmptyError"] = 10006] = "ClubLogoEmptyError";
  ErrorCode2[ErrorCode2["ClubUpdateRightError"] = 10007] = "ClubUpdateRightError";
  return ErrorCode2;
})(ErrorCode || {});

class Duration$Type extends MessageType {
  constructor() {
    super("google.protobuf.Duration", [
      {
        no: 1,
        name: "seconds",
        kind: "scalar",
        T: 3,
        L: 2
        /*LongType.NUMBER*/
      },
      {
        no: 2,
        name: "nanos",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      }
    ]);
  }
  /**
   * Encode `Duration` to JSON string like "3.000001s".
   */
  internalJsonWrite(message, options) {
    let s = PbLong.from(message.seconds).toNumber();
    if (s > 315576e6 || s < -315576e6)
      throw new Error("Duration value out of range.");
    let text = message.seconds.toString();
    if (s === 0 && message.nanos < 0)
      text = "-" + text;
    if (message.nanos !== 0) {
      let nanosStr = Math.abs(message.nanos).toString();
      nanosStr = "0".repeat(9 - nanosStr.length) + nanosStr;
      if (nanosStr.substring(3) === "000000")
        nanosStr = nanosStr.substring(0, 3);
      else if (nanosStr.substring(6) === "000")
        nanosStr = nanosStr.substring(0, 6);
      text += "." + nanosStr;
    }
    return text + "s";
  }
  /**
   * Decode `Duration` from JSON string like "3.000001s"
   */
  internalJsonRead(json, options, target) {
    if (typeof json !== "string")
      throw new Error("Unable to parse Duration from JSON " + typeofJsonValue(json) + ". Expected string.");
    let match = json.match(/^(-?)([0-9]+)(?:\.([0-9]+))?s/);
    if (match === null)
      throw new Error("Unable to parse Duration from JSON string. Invalid format.");
    if (!target)
      target = this.create();
    let [, sign, secs, nanos] = match;
    let longSeconds = PbLong.from(sign + secs);
    if (longSeconds.toNumber() > 315576e6 || longSeconds.toNumber() < -315576e6)
      throw new Error("Unable to parse Duration from JSON string. Value out of range.");
    target.seconds = longSeconds.toNumber();
    if (typeof nanos == "string") {
      let nanosStr = sign + nanos + "0".repeat(9 - nanos.length);
      target.nanos = parseInt(nanosStr);
    }
    return target;
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.seconds = 0;
    message.nanos = 0;
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* int64 seconds */
        1:
          message.seconds = reader.int64().toNumber();
          break;
        case /* int32 nanos */
        2:
          message.nanos = reader.int32();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.seconds !== 0)
      writer.tag(1, WireType.Varint).int64(message.seconds);
    if (message.nanos !== 0)
      writer.tag(2, WireType.Varint).int32(message.nanos);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const Duration = new Duration$Type();

class ErrorInfo$Type extends MessageType {
  constructor() {
    super("google.rpc.ErrorInfo", [
      {
        no: 1,
        name: "reason",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "domain",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "metadata", kind: "map", K: 9, V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      } }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.reason = "";
    message.domain = "";
    message.metadata = {};
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string reason */
        1:
          message.reason = reader.string();
          break;
        case /* string domain */
        2:
          message.domain = reader.string();
          break;
        case /* map<string, string> metadata */
        3:
          this.binaryReadMap3(message.metadata, reader, options);
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  binaryReadMap3(map, reader, options) {
    let len = reader.uint32(), end = reader.pos + len, key, val;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case 1:
          key = reader.string();
          break;
        case 2:
          val = reader.string();
          break;
        default:
          throw new globalThis.Error("unknown map entry field for field google.rpc.ErrorInfo.metadata");
      }
    }
    map[key ?? ""] = val ?? "";
  }
  internalBinaryWrite(message, writer, options) {
    if (message.reason !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.reason);
    if (message.domain !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.domain);
    for (let k of globalThis.Object.keys(message.metadata))
      writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const ErrorInfo = new ErrorInfo$Type();
class RetryInfo$Type extends MessageType {
  constructor() {
    super("google.rpc.RetryInfo", [
      { no: 1, name: "retry_delay", kind: "message", localName: "retry_delay", T: () => Duration }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* google.protobuf.Duration retry_delay */
        1:
          message.retry_delay = Duration.internalBinaryRead(reader, reader.uint32(), options, message.retry_delay);
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.retry_delay)
      Duration.internalBinaryWrite(message.retry_delay, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new RetryInfo$Type();
class DebugInfo$Type extends MessageType {
  constructor() {
    super("google.rpc.DebugInfo", [
      {
        no: 1,
        name: "stack_entries",
        kind: "scalar",
        localName: "stack_entries",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "detail",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.stack_entries = [];
    message.detail = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated string stack_entries */
        1:
          message.stack_entries.push(reader.string());
          break;
        case /* string detail */
        2:
          message.detail = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    for (let i = 0; i < message.stack_entries.length; i++)
      writer.tag(1, WireType.LengthDelimited).string(message.stack_entries[i]);
    if (message.detail !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.detail);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new DebugInfo$Type();
class QuotaFailure$Type extends MessageType {
  constructor() {
    super("google.rpc.QuotaFailure", [
      { no: 1, name: "violations", kind: "message", repeat: 1, T: () => QuotaFailure_Violation }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.violations = [];
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated google.rpc.QuotaFailure.Violation violations */
        1:
          message.violations.push(QuotaFailure_Violation.internalBinaryRead(reader, reader.uint32(), options));
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    for (let i = 0; i < message.violations.length; i++)
      QuotaFailure_Violation.internalBinaryWrite(message.violations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new QuotaFailure$Type();
class QuotaFailure_Violation$Type extends MessageType {
  constructor() {
    super("google.rpc.QuotaFailure.Violation", [
      {
        no: 1,
        name: "subject",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "description",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.subject = "";
    message.description = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string subject */
        1:
          message.subject = reader.string();
          break;
        case /* string description */
        2:
          message.description = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.subject !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.subject);
    if (message.description !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.description);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const QuotaFailure_Violation = new QuotaFailure_Violation$Type();
class PreconditionFailure$Type extends MessageType {
  constructor() {
    super("google.rpc.PreconditionFailure", [
      { no: 1, name: "violations", kind: "message", repeat: 1, T: () => PreconditionFailure_Violation }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.violations = [];
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated google.rpc.PreconditionFailure.Violation violations */
        1:
          message.violations.push(PreconditionFailure_Violation.internalBinaryRead(reader, reader.uint32(), options));
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    for (let i = 0; i < message.violations.length; i++)
      PreconditionFailure_Violation.internalBinaryWrite(message.violations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new PreconditionFailure$Type();
class PreconditionFailure_Violation$Type extends MessageType {
  constructor() {
    super("google.rpc.PreconditionFailure.Violation", [
      {
        no: 1,
        name: "type",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "subject",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "description",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.type = "";
    message.subject = "";
    message.description = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string type */
        1:
          message.type = reader.string();
          break;
        case /* string subject */
        2:
          message.subject = reader.string();
          break;
        case /* string description */
        3:
          message.description = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.type !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.type);
    if (message.subject !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.subject);
    if (message.description !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.description);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const PreconditionFailure_Violation = new PreconditionFailure_Violation$Type();
class BadRequest$Type extends MessageType {
  constructor() {
    super("google.rpc.BadRequest", [
      { no: 1, name: "field_violations", kind: "message", localName: "field_violations", repeat: 1, T: () => BadRequest_FieldViolation }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.field_violations = [];
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated google.rpc.BadRequest.FieldViolation field_violations */
        1:
          message.field_violations.push(BadRequest_FieldViolation.internalBinaryRead(reader, reader.uint32(), options));
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    for (let i = 0; i < message.field_violations.length; i++)
      BadRequest_FieldViolation.internalBinaryWrite(message.field_violations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new BadRequest$Type();
class BadRequest_FieldViolation$Type extends MessageType {
  constructor() {
    super("google.rpc.BadRequest.FieldViolation", [
      {
        no: 1,
        name: "field",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "description",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.field = "";
    message.description = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string field */
        1:
          message.field = reader.string();
          break;
        case /* string description */
        2:
          message.description = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.field !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.field);
    if (message.description !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.description);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const BadRequest_FieldViolation = new BadRequest_FieldViolation$Type();
class RequestInfo$Type extends MessageType {
  constructor() {
    super("google.rpc.RequestInfo", [
      {
        no: 1,
        name: "request_id",
        kind: "scalar",
        localName: "request_id",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "serving_data",
        kind: "scalar",
        localName: "serving_data",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.request_id = "";
    message.serving_data = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string request_id */
        1:
          message.request_id = reader.string();
          break;
        case /* string serving_data */
        2:
          message.serving_data = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.request_id !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.request_id);
    if (message.serving_data !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.serving_data);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new RequestInfo$Type();
class ResourceInfo$Type extends MessageType {
  constructor() {
    super("google.rpc.ResourceInfo", [
      {
        no: 1,
        name: "resource_type",
        kind: "scalar",
        localName: "resource_type",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "resource_name",
        kind: "scalar",
        localName: "resource_name",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "owner",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "description",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.resource_type = "";
    message.resource_name = "";
    message.owner = "";
    message.description = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string resource_type */
        1:
          message.resource_type = reader.string();
          break;
        case /* string resource_name */
        2:
          message.resource_name = reader.string();
          break;
        case /* string owner */
        3:
          message.owner = reader.string();
          break;
        case /* string description */
        4:
          message.description = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.resource_type !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.resource_type);
    if (message.resource_name !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.resource_name);
    if (message.owner !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.owner);
    if (message.description !== "")
      writer.tag(4, WireType.LengthDelimited).string(message.description);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new ResourceInfo$Type();
class Help$Type extends MessageType {
  constructor() {
    super("google.rpc.Help", [
      { no: 1, name: "links", kind: "message", repeat: 1, T: () => Help_Link }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.links = [];
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated google.rpc.Help.Link links */
        1:
          message.links.push(Help_Link.internalBinaryRead(reader, reader.uint32(), options));
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    for (let i = 0; i < message.links.length; i++)
      Help_Link.internalBinaryWrite(message.links[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new Help$Type();
class Help_Link$Type extends MessageType {
  constructor() {
    super("google.rpc.Help.Link", [
      {
        no: 1,
        name: "description",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "url",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.description = "";
    message.url = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string description */
        1:
          message.description = reader.string();
          break;
        case /* string url */
        2:
          message.url = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.description !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.description);
    if (message.url !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.url);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const Help_Link = new Help_Link$Type();
class LocalizedMessage$Type extends MessageType {
  constructor() {
    super("google.rpc.LocalizedMessage", [
      {
        no: 1,
        name: "locale",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.locale = "";
    message.message = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string locale */
        1:
          message.locale = reader.string();
          break;
        case /* string message */
        2:
          message.message = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.locale !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.locale);
    if (message.message !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.message);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new LocalizedMessage$Type();

class Any$Type extends MessageType {
  constructor() {
    super("google.protobuf.Any", [
      {
        no: 1,
        name: "type_url",
        kind: "scalar",
        localName: "type_url",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "value",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
  /**
   * Pack the message into a new `Any`.
   *
   * Uses 'type.googleapis.com/full.type.name' as the type URL.
   */
  pack(message, type) {
    return {
      type_url: this.typeNameToUrl(type.typeName),
      value: type.toBinary(message)
    };
  }
  /**
   * Unpack the message from the `Any`.
   */
  unpack(any, type, options) {
    if (!this.contains(any, type))
      throw new Error("Cannot unpack google.protobuf.Any with type_url '" + any.type_url + "' as " + type.typeName + ".");
    return type.fromBinary(any.value, options);
  }
  /**
   * Does the given `Any` contain a packed message of the given type?
   */
  contains(any, type) {
    if (!any.type_url.length)
      return false;
    let wants = typeof type == "string" ? type : type.typeName;
    let has = this.typeUrlToName(any.type_url);
    return wants === has;
  }
  /**
   * Convert the message to canonical JSON value.
   *
   * You have to provide the `typeRegistry` option so that the
   * packed message can be converted to JSON.
   *
   * The `typeRegistry` option is also required to read
   * `google.protobuf.Any` from JSON format.
   */
  internalJsonWrite(any, options) {
    if (any.type_url === "")
      return {};
    let typeName = this.typeUrlToName(any.type_url);
    let opt = jsonWriteOptions(options);
    let type = opt.typeRegistry?.find((t) => t.typeName === typeName);
    if (!type)
      throw new globalThis.Error("Unable to convert google.protobuf.Any with typeUrl '" + any.type_url + "' to JSON. The specified type " + typeName + " is not available in the type registry.");
    let value = type.fromBinary(any.value, { readUnknownField: false });
    let json = type.internalJsonWrite(value, opt);
    if (typeName.startsWith("google.protobuf.") || !isJsonObject(json))
      json = { value: json };
    json["@type"] = any.type_url;
    return json;
  }
  internalJsonRead(json, options, target) {
    if (!isJsonObject(json))
      throw new globalThis.Error("Unable to parse google.protobuf.Any from JSON " + typeofJsonValue(json) + ".");
    if (typeof json["@type"] != "string" || json["@type"] == "")
      return this.create();
    let typeName = this.typeUrlToName(json["@type"]);
    let type = options?.typeRegistry?.find((t) => t.typeName == typeName);
    if (!type)
      throw new globalThis.Error("Unable to parse google.protobuf.Any from JSON. The specified type " + typeName + " is not available in the type registry.");
    let value;
    if (typeName.startsWith("google.protobuf.") && json.hasOwnProperty("value"))
      value = type.fromJson(json["value"], options);
    else {
      let copy = Object.assign({}, json);
      delete copy["@type"];
      value = type.fromJson(copy, options);
    }
    if (target === void 0)
      target = this.create();
    target.type_url = json["@type"];
    target.value = type.toBinary(value);
    return target;
  }
  typeNameToUrl(name) {
    if (!name.length)
      throw new Error("invalid type name: " + name);
    return "type.googleapis.com/" + name;
  }
  typeUrlToName(url) {
    if (!url.length)
      throw new Error("invalid type url: " + url);
    let slash = url.lastIndexOf("/");
    let name = slash > 0 ? url.substring(slash + 1) : url;
    if (!name.length)
      throw new Error("invalid type url: " + url);
    return name;
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.type_url = "";
    message.value = new Uint8Array(0);
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string type_url */
        1:
          message.type_url = reader.string();
          break;
        case /* bytes value */
        2:
          message.value = reader.bytes();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.type_url !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.type_url);
    if (message.value.length)
      writer.tag(2, WireType.LengthDelimited).bytes(message.value);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const Any = new Any$Type();

class Status$Type extends MessageType {
  constructor() {
    super("google.rpc.Status", [
      {
        no: 1,
        name: "code",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 2,
        name: "message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "details", kind: "message", repeat: 1, T: () => Any }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.code = 0;
    message.message = "";
    message.details = [];
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* int32 code */
        1:
          message.code = reader.int32();
          break;
        case /* string message */
        2:
          message.message = reader.string();
          break;
        case /* repeated google.protobuf.Any details */
        3:
          message.details.push(Any.internalBinaryRead(reader, reader.uint32(), options));
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.code !== 0)
      writer.tag(1, WireType.Varint).int32(message.code);
    if (message.message !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.message);
    for (let i = 0; i < message.details.length; i++)
      Any.internalBinaryWrite(message.details[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const Status = new Status$Type();

var __defProp$5 = Object.defineProperty;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$5 = (obj, key, value) => __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
class SrvTime {
  constructor() {
    /** 时间差（毫秒） */
    __publicField$5(this, "timeDiff", 0);
    /** 时间差（秒） */
    __publicField$5(this, "secondsDiff", 0);
    makeAutoObservable(this);
  }
  /**
   * Calculates the server timestamp based on the given timestamp and the time difference.
   *
   * @param {number} time - The timestamp to calculate the server timestamp from.
   * @param {'timestamp' | 'seconds'} [unit='timestamp'] - The unit of the timestamp.
   * @return {number} The server timestamp calculated from the given timestamp and the time difference.
   */
  time(time, unit = "timestamp") {
    switch (unit) {
      case "timestamp":
        return this.timestamp(time);
      case "seconds":
        return this.timeSeconds(time);
      default:
        return time;
    }
  }
  /**
   * Calculates the server timestamp based on the given timestamp and the time difference.
   *
   * @param {number} timestamp - The timestamp to calculate the server timestamp from.
   * @return {number} The server timestamp calculated from the given timestamp and the time difference.
   */
  timestamp(timestamp = 0) {
    return timestamp ? timestamp + this.timeDiff : 0;
  }
  /**
   * Calculates the server timestamp in seconds based on the given number of seconds and the time difference.
   *
   * @param {number} seconds - The number of seconds to calculate the server timestamp from.
   * @return {number} The server timestamp calculated from the given number of seconds and the time difference.
   */
  timeSeconds(seconds = 0) {
    return seconds ? seconds + this.secondsDiff : 0;
  }
  /** 更新服务与本地时间差 */
  updateDiff(diff) {
    if (Math.abs(diff) < 3e3) return;
    this.timeDiff = diff;
    this.secondsDiff = Math.round(diff / 1e3);
  }
}
const srvTime = new SrvTime();

const logger = loglevel.getLogger("GRPC CLIENT");
const originalFactory = logger.methodFactory;
function reInitLogger(isDev, isProd) {
  if (isProd) {
    logger.setLevel(logger.levels.SILENT);
  } else {
    logger.setLevel(logger.levels.TRACE);
  }
  logger.methodFactory = function(methodName, logLevel, loggerName) {
    const rawMethod = originalFactory(methodName, logLevel, loggerName);
    return function(message, ...args) {
      const colors = {
        TRACE: "#9B30FF",
        DEBUG: "#00B050",
        INFO: "#1E90FF",
        WARN: "#FFA500",
        ERROR: "#FF4040"
      };
      const timestamp = format(/* @__PURE__ */ new Date(), "HH:mm:ss");
      const moduleName = loggerName || "Default";
      const style = `color: ${colors[methodName.toUpperCase()]}`;
      const formattedMessage = `%c[${String(moduleName)}][${timestamp}] ${message}`;
      if (isDev) {
        console.log(formattedMessage, style, ...args);
      } else {
        rawMethod(formattedMessage, style, ...args);
      }
    };
  };
  logger.setLevel(logger.getLevel());
}

var GrpcStatusCode = /* @__PURE__ */ ((GrpcStatusCode2) => {
  GrpcStatusCode2[GrpcStatusCode2["OK"] = 0] = "OK";
  GrpcStatusCode2[GrpcStatusCode2["CANCELLED"] = 1] = "CANCELLED";
  GrpcStatusCode2[GrpcStatusCode2["UNKNOWN"] = 2] = "UNKNOWN";
  GrpcStatusCode2[GrpcStatusCode2["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
  GrpcStatusCode2[GrpcStatusCode2["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
  GrpcStatusCode2[GrpcStatusCode2["NOT_FOUND"] = 5] = "NOT_FOUND";
  GrpcStatusCode2[GrpcStatusCode2["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
  GrpcStatusCode2[GrpcStatusCode2["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
  GrpcStatusCode2[GrpcStatusCode2["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
  GrpcStatusCode2[GrpcStatusCode2["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
  GrpcStatusCode2[GrpcStatusCode2["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
  GrpcStatusCode2[GrpcStatusCode2["ABORTED"] = 10] = "ABORTED";
  GrpcStatusCode2[GrpcStatusCode2["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
  GrpcStatusCode2[GrpcStatusCode2["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
  GrpcStatusCode2[GrpcStatusCode2["INTERNAL"] = 13] = "INTERNAL";
  GrpcStatusCode2[GrpcStatusCode2["UNAVAILABLE"] = 14] = "UNAVAILABLE";
  GrpcStatusCode2[GrpcStatusCode2["DATA_LOSS"] = 15] = "DATA_LOSS";
  return GrpcStatusCode2;
})(GrpcStatusCode || {});

function createGrpcWebRequestHeader(headers, format, timeout, meta, userAgent) {
  if (meta) {
    for (const [k, v] of Object.entries(meta)) {
      if (typeof v == "string") {
        if (v) {
          headers.append(k, v);
        }
      } else {
        for (const i of v) headers.append(k, i);
      }
    }
  }
  headers.set("Content-Type", format === "text" ? "application/grpc-web-text" : "application/grpc-web+proto");
  if (format == "text") {
    headers.set("Accept", "application/grpc-web-text");
  }
  headers.set("X-Grpc-Web", "1");
  if (userAgent) headers.set("X-User-Agent", userAgent);
  if (typeof timeout === "number") {
    if (timeout <= 0) {
      throw new RpcError(`timeout ${timeout} ms exceeded`, GrpcStatusCode[GrpcStatusCode.DEADLINE_EXCEEDED]);
    }
    headers.set("grpc-timeout", `${timeout}m`);
  } else if (timeout) {
    const deadline = timeout.getTime();
    const now = Date.now();
    if (deadline <= now) {
      throw new RpcError(`deadline ${timeout} exceeded`, GrpcStatusCode[GrpcStatusCode.DEADLINE_EXCEEDED]);
    }
    headers.set("grpc-timeout", `${deadline - now}m`);
  }
  return headers;
}
function createGrpcWebRequestBody(message, format) {
  const body = new Uint8Array(5 + message.length);
  body[0] = 0 /* DATA */;
  for (let msgLen = message.length, i = 4; i > 0; i--) {
    body[i] = msgLen % 256;
    msgLen >>>= 8;
  }
  body.set(message, 5);
  return format === "binary" ? body : base64encode(body);
}
function readGrpcWebResponseHeader(headersOrFetchResponse, httpStatus, httpStatusText) {
  if (arguments.length === 1) {
    const fetchResponse = headersOrFetchResponse;
    let responseType;
    try {
      responseType = fetchResponse.type;
    } catch {
    }
    switch (responseType) {
      case "error":
      case "opaque":
      case "opaqueredirect":
        throw new RpcError(`fetch response type ${fetchResponse.type}`, GrpcStatusCode[GrpcStatusCode.UNKNOWN]);
    }
    return readGrpcWebResponseHeader(
      fetchHeadersToHttp(fetchResponse.headers),
      fetchResponse.status,
      fetchResponse.statusText
    );
  }
  const headers = headersOrFetchResponse, httpOk = httpStatus >= 200 && httpStatus < 300, responseMeta = parseMetadata(headers);
  let [statusCode, statusDetail] = parseStatus(headers);
  if ((statusCode === void 0 || statusCode === GrpcStatusCode.OK) && !httpOk) {
    statusCode = httpStatusToGrpc(httpStatus);
    statusDetail = httpStatusText;
  }
  return [statusCode, statusDetail, responseMeta];
}
function readGrpcWebResponseTrailer(data) {
  const headers = parseTrailer(data), [code, detail] = parseStatus(headers), meta = parseMetadata(headers);
  return [code ?? GrpcStatusCode.OK, detail, meta];
}
var GrpcWebFrame = /* @__PURE__ */ ((GrpcWebFrame2) => {
  GrpcWebFrame2[GrpcWebFrame2["DATA"] = 0] = "DATA";
  GrpcWebFrame2[GrpcWebFrame2["TRAILER"] = 128] = "TRAILER";
  return GrpcWebFrame2;
})(GrpcWebFrame || {});
async function readGrpcWebResponseBody(stream, contentType, onFrame) {
  let streamReader, base64queue = "", byteQueue = new Uint8Array(0);
  const format = parseFormat(contentType);
  if (isReadableStream(stream)) {
    const whatWgReadableStream = stream.getReader();
    streamReader = {
      next: () => whatWgReadableStream.read()
    };
  } else {
    streamReader = stream[Symbol.asyncIterator]();
  }
  while (true) {
    const result = await streamReader.next();
    if (result.value !== void 0) {
      if (format === "text") {
        for (let i = 0; i < result.value.length; i++) base64queue += String.fromCharCode(result.value[i]);
        const safeLen = base64queue.length - base64queue.length % 4;
        if (safeLen === 0) continue;
        byteQueue = concatBytes(byteQueue, base64decode(base64queue.substring(0, safeLen)));
        base64queue = base64queue.substring(safeLen);
      } else {
        byteQueue = concatBytes(byteQueue, result.value);
      }
      while (byteQueue.length >= 5 && byteQueue[0] === 0 /* DATA */) {
        let msgLen = 0;
        for (let i = 1; i < 5; i++) msgLen = (msgLen << 8) + byteQueue[i];
        if (byteQueue.length - 5 >= msgLen) {
          onFrame(0 /* DATA */, byteQueue.subarray(5, 5 + msgLen));
          byteQueue = byteQueue.subarray(5 + msgLen);
        } else break;
      }
    }
    if (result.done) {
      if (byteQueue.length === 0) break;
      if (byteQueue[0] !== 128 /* TRAILER */ || byteQueue.length < 5)
        throw new RpcError("premature EOF", GrpcStatusCode[GrpcStatusCode.DATA_LOSS]);
      onFrame(128 /* TRAILER */, byteQueue.subarray(5));
      break;
    }
  }
}
const isReadableStream = (s) => {
  return typeof s.getReader == "function";
};
function concatBytes(a, b) {
  const n = new Uint8Array(a.length + b.length);
  n.set(a);
  n.set(b, a.length);
  return n;
}
function parseFormat(contentType) {
  switch (contentType) {
    case "application/grpc-web-text":
    case "application/grpc-web-text+proto":
      return "text";
    case "application/grpc-web":
    case "application/grpc-web+proto":
      return "binary";
    case void 0:
    case null:
      throw new RpcError("missing response content type", GrpcStatusCode[GrpcStatusCode.INTERNAL]);
    default:
      throw new RpcError("unexpected response content type: " + contentType, GrpcStatusCode[GrpcStatusCode.INTERNAL]);
  }
}
function parseStatus(headers) {
  let code, message;
  const m = headers["grpc-message"];
  if (m !== void 0) {
    if (Array.isArray(m)) return [GrpcStatusCode.INTERNAL, "invalid grpc-web message"];
    message = m;
  }
  const s = headers["grpc-status"];
  if (s !== void 0) {
    if (Array.isArray(s)) return [GrpcStatusCode.INTERNAL, "invalid grpc-web status"];
    code = parseInt(s, 10);
    if (GrpcStatusCode[code] === void 0) return [GrpcStatusCode.INTERNAL, "invalid grpc-web status"];
  }
  return [code, message];
}
function parseMetadata(headers) {
  const meta = {};
  for (const [k, v] of Object.entries(headers))
    switch (k) {
      case "grpc-message":
      case "grpc-status":
      case "content-type":
        break;
      default:
        meta[k] = v;
    }
  return meta;
}
function parseTrailer(trailerData) {
  const headers = {};
  for (const chunk of String.fromCharCode.apply(String, trailerData).trim().split("\r\n")) {
    if (chunk == "") continue;
    let [key, ...val] = chunk.split(":");
    const value = val.join(":").trim();
    key = key.trim();
    const e = headers[key];
    if (typeof e == "string") headers[key] = [e, value];
    else if (Array.isArray(e)) e.push(value);
    else headers[key] = value;
  }
  return headers;
}
function fetchHeadersToHttp(fetchHeaders) {
  const headers = {};
  fetchHeaders.forEach((value, key) => {
    const e = headers[key];
    if (typeof e == "string") headers[key] = [e, value];
    else if (Array.isArray(e)) e.push(value);
    else headers[key] = value;
  });
  return headers;
}
function httpStatusToGrpc(httpStatus) {
  switch (httpStatus) {
    case 200:
      return GrpcStatusCode.OK;
    case 400:
      return GrpcStatusCode.INVALID_ARGUMENT;
    case 401:
      return GrpcStatusCode.UNAUTHENTICATED;
    case 403:
      return GrpcStatusCode.PERMISSION_DENIED;
    case 404:
      return GrpcStatusCode.NOT_FOUND;
    case 409:
      return GrpcStatusCode.ABORTED;
    case 412:
      return GrpcStatusCode.FAILED_PRECONDITION;
    case 429:
      return GrpcStatusCode.RESOURCE_EXHAUSTED;
    case 499:
      return GrpcStatusCode.CANCELLED;
    case 500:
      return GrpcStatusCode.UNKNOWN;
    case 501:
      return GrpcStatusCode.UNIMPLEMENTED;
    case 503:
      return GrpcStatusCode.UNAVAILABLE;
    case 504:
      return GrpcStatusCode.DEADLINE_EXCEEDED;
    default:
      return GrpcStatusCode.UNKNOWN;
  }
}

var __defProp$4 = Object.defineProperty;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$4 = (obj, key, value) => __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
class GRPCError extends RpcError {
  constructor() {
    super(...arguments);
    __publicField$4(this, "_errCode");
    __publicField$4(this, "_reason");
    __publicField$4(this, "_raw");
  }
  get errCode() {
    return this._errCode;
  }
  set errCode(value) {
    this._errCode = value;
  }
  get reason() {
    return this._reason;
  }
  set reason(value) {
    this._reason = value;
  }
  get raw() {
    return this._raw;
  }
  set raw(value) {
    this._raw = value;
  }
}

var __defProp$3 = Object.defineProperty;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$3 = (obj, key, value) => __defNormalProp$3(obj, key + "" , value);
function getGRPCError(e) {
  let reason;
  let message;
  let status;
  if (e instanceof RpcError) {
    const meta = e.meta;
    const bin = meta["grpc-status-details-bin"];
    if (bin) {
      status = Status.fromBinary(Base64.toUint8Array(bin));
      message = status.message;
      for (let index = 0; index < status.details.length; index++) {
        const element = status.details[index];
        element.value = ErrorInfo.fromBinary(element.value);
        reason = element.value.reason;
      }
    }
  }
  const err = new GRPCError(message || e.message, e.code, e.meta);
  err.errCode = ErrorCode[reason];
  err.reason = reason;
  err.raw = status;
  return err;
}
class GrpcWebFetchTransport {
  constructor(defaultOptions) {
    __publicField$3(this, "defaultOptions");
    this.defaultOptions = defaultOptions;
  }
  /**
   * objectAssign
   * mutationFn 如果返回 falsy, 直接使用原来的值
   **/
  setOptions(optionOrFn) {
    if (typeof optionOrFn === "function") {
      this.defaultOptions = optionOrFn(this.defaultOptions) || this.defaultOptions;
    } else {
      this.defaultOptions = Object.assign(this.defaultOptions, optionOrFn);
    }
  }
  mergeOptions(options) {
    return mergeRpcOptions(this.defaultOptions, options);
  }
  /**
   * Create an URI for a gRPC web call.
   *
   * Takes the `baseUrl` option and appends:
   * - slash "/"
   * - package name
   * - dot "."
   * - service name
   * - slash "/"
   * - method name
   *
   * If the service was declared without a package, the package name and dot
   * are omitted.
   *
   * All names are used exactly like declared in .proto.
   */
  makeUrl(method, options) {
    let base = options.baseUrl;
    if (typeof options.getBaseUrl === "function") {
      base = options.getBaseUrl();
    } else {
      base = options.baseUrl;
    }
    if (base?.endsWith("/")) base = base.substring(0, base.length - 1);
    const addon = options.baseUrlAddon || "";
    return `${base}${addon}/${method.service.typeName}/${method.name}`;
  }
  clientStreaming(method) {
    const e = new RpcError(
      "Client streaming is not supported by grpc-web",
      GrpcStatusCode[GrpcStatusCode.UNIMPLEMENTED]
    );
    e.methodName = method.name;
    e.serviceName = method.service.typeName;
    throw e;
  }
  duplex(method) {
    const e = new RpcError(
      "Duplex streaming is not supported by grpc-web",
      GrpcStatusCode[GrpcStatusCode.UNIMPLEMENTED]
    );
    e.methodName = method.name;
    e.serviceName = method.service.typeName;
    throw e;
  }
  serverStreaming(method, input, options) {
    let opt = options, format = opt.format ?? "text", fetchInit = opt.fetchInit ?? {}, url = this.makeUrl(method, opt), inputBytes = method.I.toBinary(input, opt.binaryOptions), defHeader = new Deferred(), responseStream = new RpcOutputStreamController(), responseEmptyBody = true, maybeStatus, defStatus = new Deferred(), maybeTrailer, defTrailer = new Deferred();
    globalThis.fetch(url, {
      ...fetchInit,
      method: "POST",
      headers: createGrpcWebRequestHeader(new globalThis.Headers(), format, opt.timeout, opt.meta),
      body: createGrpcWebRequestBody(inputBytes, format),
      signal: options.abort ?? null
      // node-fetch@3.0.0-beta.9 rejects `undefined`
    }).then((fetchResponse) => {
      const [code, detail, meta] = readGrpcWebResponseHeader(fetchResponse);
      defHeader.resolve(meta);
      if (code != null && code !== GrpcStatusCode.OK)
        throw new RpcError(detail ?? GrpcStatusCode[code], GrpcStatusCode[code], meta);
      if (code != null)
        maybeStatus = {
          code: GrpcStatusCode[code],
          detail: detail ?? GrpcStatusCode[code]
        };
      return fetchResponse;
    }).then((fetchResponse) => {
      if (!fetchResponse.body) throw new RpcError("missing response body", GrpcStatusCode[GrpcStatusCode.INTERNAL]);
      const headerDate = fetchResponse.headers.get("Date");
      srvTime.updateDiff(differenceInMilliseconds(/* @__PURE__ */ new Date(), new Date(headerDate || /* @__PURE__ */ new Date())));
      return readGrpcWebResponseBody(fetchResponse.body, fetchResponse.headers.get("content-type"), (type, data) => {
        switch (type) {
          case GrpcWebFrame.DATA:
            responseStream.notifyMessage(method.O.fromBinary(data, opt.binaryOptions));
            responseEmptyBody = false;
            break;
          case GrpcWebFrame.TRAILER:
            let code, detail;
            [code, detail, maybeTrailer] = readGrpcWebResponseTrailer(data);
            maybeStatus = {
              code: GrpcStatusCode[code],
              detail: detail ?? GrpcStatusCode[code]
            };
            break;
        }
      });
    }).then(() => {
      if (!maybeTrailer && !responseEmptyBody)
        throw new RpcError(`missing trailers`, GrpcStatusCode[GrpcStatusCode.DATA_LOSS]);
      if (!maybeStatus) throw new RpcError(`missing status`, GrpcStatusCode[GrpcStatusCode.INTERNAL]);
      if (maybeStatus.code !== "OK") throw new RpcError(maybeStatus.detail, maybeStatus.code, maybeTrailer);
      responseStream.notifyComplete();
      defStatus.resolve(maybeStatus);
      defTrailer.resolve(maybeTrailer || {});
    }).catch((reason) => {
      let error;
      if (reason instanceof RpcError) error = reason;
      else if (reason instanceof Error && reason.name === "AbortError") {
        error = new RpcError(reason.message, GrpcStatusCode[GrpcStatusCode.CANCELLED]);
        error.stack = reason.stack;
      } else {
        error = new RpcError(
          reason instanceof Error ? reason.message : "" + reason,
          GrpcStatusCode[GrpcStatusCode.INTERNAL]
        );
        if (reason.stack) {
          error.stack = reason.stack;
        }
      }
      error.methodName = method.name;
      error.serviceName = method.service.typeName;
      defHeader.rejectPending(error);
      responseStream.notifyError(error);
      defStatus.rejectPending(error);
      defTrailer.rejectPending(error);
    });
    return new ServerStreamingCall(
      method,
      opt.meta ?? {},
      input,
      defHeader.promise,
      responseStream,
      defStatus.promise,
      defTrailer.promise
    );
  }
  unary(method, input, options) {
    let opt = options, format = opt.format ?? "text", fetchInit = opt.fetchInit ?? {}, url = this.makeUrl(method, opt), inputBytes = method.I.toBinary(input, opt.binaryOptions), defHeader = new Deferred(), maybeMessage, defMessage = new Deferred(), maybeStatus, defStatus = new Deferred(), maybeTrailer, defTrailer = new Deferred(), headers = opt.headers || {};
    logger.debug(`GRPC \u8BF7\u6C42 ${url}`, opt, input);
    const extendsHeaders = createGrpcWebRequestHeader(new globalThis.Headers(headers), format, opt.timeout, opt.meta);
    globalThis.fetch(url, {
      ...fetchInit,
      method: "POST",
      headers: extendsHeaders,
      body: createGrpcWebRequestBody(inputBytes, format),
      signal: options.abort ?? null
      // node-fetch@3.0.0-beta.9 rejects `undefined`
    }).then((fetchResponse) => {
      const [code, detail, meta] = readGrpcWebResponseHeader(fetchResponse);
      defHeader.resolve(meta);
      if (code != null && code !== GrpcStatusCode.OK) {
        const grpcError = new RpcError(detail ?? GrpcStatusCode[code], GrpcStatusCode[code], meta);
        logger.error(`GRPC \u8BF7\u6C42\u5F02\u5E38(code)`, { url, code, input, detail, grpcError });
        throw grpcError;
      }
      if (code != null)
        maybeStatus = {
          code: GrpcStatusCode[code],
          detail: detail ?? GrpcStatusCode[code]
        };
      return fetchResponse;
    }).then((fetchResponse) => {
      if (!fetchResponse.body) {
        const grpcError = new RpcError("missing response body", GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        logger.error(`GRPC \u8BF7\u6C42\u5F02\u5E38(body)`, { fetchResponse, grpcError });
        throw grpcError;
      }
      const headerDate = fetchResponse.headers.get("Date");
      srvTime.updateDiff(differenceInMilliseconds(/* @__PURE__ */ new Date(), new Date(headerDate || /* @__PURE__ */ new Date())));
      return readGrpcWebResponseBody(fetchResponse.body, fetchResponse.headers.get("content-type"), (type, data) => {
        switch (type) {
          case GrpcWebFrame.DATA:
            if (maybeMessage)
              throw new RpcError(`unary call received 2nd message`, GrpcStatusCode[GrpcStatusCode.DATA_LOSS]);
            maybeMessage = method.O.fromBinary(data, opt.binaryOptions);
            break;
          case GrpcWebFrame.TRAILER:
            let code, detail;
            [code, detail, maybeTrailer] = readGrpcWebResponseTrailer(data);
            maybeStatus = {
              code: GrpcStatusCode[code],
              detail: detail ?? GrpcStatusCode[code]
            };
            break;
        }
      });
    }).then(() => {
      if (!maybeMessage) throw new RpcError(maybeStatus?.detail + url, maybeStatus?.code, maybeTrailer);
      logger.debug(`GRPC \u54CD\u5E94 ${url}`, maybeMessage);
      defMessage.resolve(maybeMessage);
      defStatus.resolve(maybeStatus);
      defTrailer.resolve(maybeTrailer || {});
    }).catch((reason) => {
      let error = null;
      if (reason instanceof RpcError) {
        error = getGRPCError(reason);
      } else if (reason instanceof Error && reason.name === "AbortError") {
        error = new RpcError(reason.message, GrpcStatusCode[GrpcStatusCode.CANCELLED]);
        error.stack = reason.stack;
      } else {
        error = new RpcError(
          reason instanceof Error ? reason.message : "" + reason,
          GrpcStatusCode[GrpcStatusCode.INTERNAL]
        );
        if (reason.stack) {
          error.stack = reason.stack;
        }
      }
      error.methodName = method.name;
      error.serviceName = method.service.typeName;
      logger.error(`GRPC \u8BF7\u6C42\u5F02\u5E38(catch)`, { grpcError: error });
      defHeader.rejectPending(error);
      defMessage.rejectPending(error);
      defStatus.rejectPending(error);
      defTrailer.rejectPending(error);
    });
    return new UnaryCall(
      method,
      opt.meta ?? {},
      input,
      defHeader.promise,
      defMessage.promise,
      defStatus.promise,
      defTrailer.promise
    );
  }
}

var AuthReply_Code = /* @__PURE__ */ ((AuthReply_Code2) => {
  AuthReply_Code2[AuthReply_Code2["OK"] = 0] = "OK";
  AuthReply_Code2[AuthReply_Code2["Unauthenticated"] = 16] = "Unauthenticated";
  return AuthReply_Code2;
})(AuthReply_Code || {});
class Proto$Type extends MessageType {
  constructor() {
    super("infra.protocol.Proto", [
      {
        no: 1,
        name: "ver",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 2,
        name: "op",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 3,
        name: "seq",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 4,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.ver = 0;
    message.op = 0;
    message.seq = 0;
    message.body = new Uint8Array(0);
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* int32 ver */
        1:
          message.ver = reader.int32();
          break;
        case /* int32 op */
        2:
          message.op = reader.int32();
          break;
        case /* int32 seq */
        3:
          message.seq = reader.int32();
          break;
        case /* bytes body */
        4:
          message.body = reader.bytes();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.ver !== 0)
      writer.tag(1, WireType.Varint).int32(message.ver);
    if (message.op !== 0)
      writer.tag(2, WireType.Varint).int32(message.op);
    if (message.seq !== 0)
      writer.tag(3, WireType.Varint).int32(message.seq);
    if (message.body.length)
      writer.tag(4, WireType.LengthDelimited).bytes(message.body);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new Proto$Type();
class GrpcCallReq$Type extends MessageType {
  constructor() {
    super("infra.protocol.GrpcCallReq", [
      {
        no: 1,
        name: "fullMethodName",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "req",
        kind: "scalar",
        T: 13
        /*ScalarType.UINT32*/
      },
      {
        no: 3,
        name: "destID",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      },
      { no: 5, name: "metadata", kind: "map", K: 9, V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      } }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.fullMethodName = "";
    message.req = 0;
    message.destID = "";
    message.body = new Uint8Array(0);
    message.metadata = {};
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string fullMethodName */
        1:
          message.fullMethodName = reader.string();
          break;
        case /* uint32 req */
        2:
          message.req = reader.uint32();
          break;
        case /* string destID */
        3:
          message.destID = reader.string();
          break;
        case /* bytes body */
        4:
          message.body = reader.bytes();
          break;
        case /* map<string, string> metadata */
        5:
          this.binaryReadMap5(message.metadata, reader, options);
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  binaryReadMap5(map, reader, options) {
    let len = reader.uint32(), end = reader.pos + len, key, val;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case 1:
          key = reader.string();
          break;
        case 2:
          val = reader.string();
          break;
        default:
          throw new globalThis.Error("unknown map entry field for field infra.protocol.GrpcCallReq.metadata");
      }
    }
    map[key ?? ""] = val ?? "";
  }
  internalBinaryWrite(message, writer, options) {
    if (message.fullMethodName !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.fullMethodName);
    if (message.req !== 0)
      writer.tag(2, WireType.Varint).uint32(message.req);
    if (message.destID !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.destID);
    if (message.body.length)
      writer.tag(4, WireType.LengthDelimited).bytes(message.body);
    for (let k of globalThis.Object.keys(message.metadata))
      writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const GrpcCallReq = new GrpcCallReq$Type();
class GrpcCallReply$Type extends MessageType {
  constructor() {
    super("infra.protocol.GrpcCallReply", [
      {
        no: 1,
        name: "fullMethodName",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "req",
        kind: "scalar",
        T: 13
        /*ScalarType.UINT32*/
      },
      {
        no: 3,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      },
      { no: 4, name: "metadata", kind: "map", K: 9, V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      } },
      {
        no: 5,
        name: "err",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 6,
        name: "errMsg",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 7,
        name: "errReson",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.fullMethodName = "";
    message.req = 0;
    message.body = new Uint8Array(0);
    message.metadata = {};
    message.err = 0;
    message.errMsg = "";
    message.errReson = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string fullMethodName */
        1:
          message.fullMethodName = reader.string();
          break;
        case /* uint32 req */
        2:
          message.req = reader.uint32();
          break;
        case /* bytes body */
        3:
          message.body = reader.bytes();
          break;
        case /* map<string, string> metadata */
        4:
          this.binaryReadMap4(message.metadata, reader, options);
          break;
        case /* int32 err */
        5:
          message.err = reader.int32();
          break;
        case /* string errMsg */
        6:
          message.errMsg = reader.string();
          break;
        case /* string errReson */
        7:
          message.errReson = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  binaryReadMap4(map, reader, options) {
    let len = reader.uint32(), end = reader.pos + len, key, val;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case 1:
          key = reader.string();
          break;
        case 2:
          val = reader.string();
          break;
        default:
          throw new globalThis.Error("unknown map entry field for field infra.protocol.GrpcCallReply.metadata");
      }
    }
    map[key ?? ""] = val ?? "";
  }
  internalBinaryWrite(message, writer, options) {
    if (message.fullMethodName !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.fullMethodName);
    if (message.req !== 0)
      writer.tag(2, WireType.Varint).uint32(message.req);
    if (message.body.length)
      writer.tag(3, WireType.LengthDelimited).bytes(message.body);
    for (let k of globalThis.Object.keys(message.metadata))
      writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
    if (message.err !== 0)
      writer.tag(5, WireType.Varint).int32(message.err);
    if (message.errMsg !== "")
      writer.tag(6, WireType.LengthDelimited).string(message.errMsg);
    if (message.errReson !== "")
      writer.tag(7, WireType.LengthDelimited).string(message.errReson);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const GrpcCallReply = new GrpcCallReply$Type();
class PushReq$Type extends MessageType {
  constructor() {
    super("infra.protocol.PushReq", [
      {
        no: 1,
        name: "fullMethodName",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      },
      {
        no: 3,
        name: "roomId",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.fullMethodName = "";
    message.body = new Uint8Array(0);
    message.roomId = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string fullMethodName */
        1:
          message.fullMethodName = reader.string();
          break;
        case /* bytes body */
        2:
          message.body = reader.bytes();
          break;
        case /* string roomId */
        3:
          message.roomId = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.fullMethodName !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.fullMethodName);
    if (message.body.length)
      writer.tag(2, WireType.LengthDelimited).bytes(message.body);
    if (message.roomId !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.roomId);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const PushReq = new PushReq$Type();
class AuthReply$Type extends MessageType {
  constructor() {
    super("infra.protocol.AuthReply", [
      { no: 1, name: "code", kind: "enum", T: () => ["infra.protocol.AuthReply.Code", AuthReply_Code] },
      {
        no: 2,
        name: "authKey",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.code = 0;
    message.authKey = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* infra.protocol.AuthReply.Code code */
        1:
          message.code = reader.int32();
          break;
        case /* string authKey */
        2:
          message.authKey = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.code !== 0)
      writer.tag(1, WireType.Varint).int32(message.code);
    if (message.authKey !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.authKey);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
const AuthReply = new AuthReply$Type();
class CallPack$Type extends MessageType {
  constructor() {
    super("infra.protocol.CallPack", [
      {
        no: 1,
        name: "fullMethodName",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "req",
        kind: "scalar",
        T: 13
        /*ScalarType.UINT32*/
      },
      {
        no: 3,
        name: "destID",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      },
      { no: 5, name: "metadata", kind: "map", K: 9, V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      } }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.fullMethodName = "";
    message.req = 0;
    message.destID = "";
    message.body = new Uint8Array(0);
    message.metadata = {};
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string fullMethodName */
        1:
          message.fullMethodName = reader.string();
          break;
        case /* uint32 req */
        2:
          message.req = reader.uint32();
          break;
        case /* string destID */
        3:
          message.destID = reader.string();
          break;
        case /* bytes body */
        4:
          message.body = reader.bytes();
          break;
        case /* map<string, string> metadata */
        5:
          this.binaryReadMap5(message.metadata, reader, options);
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  binaryReadMap5(map, reader, options) {
    let len = reader.uint32(), end = reader.pos + len, key, val;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case 1:
          key = reader.string();
          break;
        case 2:
          val = reader.string();
          break;
        default:
          throw new globalThis.Error("unknown map entry field for field infra.protocol.CallPack.metadata");
      }
    }
    map[key ?? ""] = val ?? "";
  }
  internalBinaryWrite(message, writer, options) {
    if (message.fullMethodName !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.fullMethodName);
    if (message.req !== 0)
      writer.tag(2, WireType.Varint).uint32(message.req);
    if (message.destID !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.destID);
    if (message.body.length)
      writer.tag(4, WireType.LengthDelimited).bytes(message.body);
    for (let k of globalThis.Object.keys(message.metadata))
      writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new CallPack$Type();
class RespPack$Type extends MessageType {
  constructor() {
    super("infra.protocol.RespPack", [
      {
        no: 1,
        name: "fullMethodName",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "req",
        kind: "scalar",
        T: 13
        /*ScalarType.UINT32*/
      },
      {
        no: 3,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      },
      { no: 4, name: "metadata", kind: "map", K: 9, V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      } },
      {
        no: 5,
        name: "err",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 6,
        name: "errMsg",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 7,
        name: "errReson",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.fullMethodName = "";
    message.req = 0;
    message.body = new Uint8Array(0);
    message.metadata = {};
    message.err = 0;
    message.errMsg = "";
    message.errReson = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string fullMethodName */
        1:
          message.fullMethodName = reader.string();
          break;
        case /* uint32 req */
        2:
          message.req = reader.uint32();
          break;
        case /* bytes body */
        3:
          message.body = reader.bytes();
          break;
        case /* map<string, string> metadata */
        4:
          this.binaryReadMap4(message.metadata, reader, options);
          break;
        case /* int32 err */
        5:
          message.err = reader.int32();
          break;
        case /* string errMsg */
        6:
          message.errMsg = reader.string();
          break;
        case /* string errReson */
        7:
          message.errReson = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  binaryReadMap4(map, reader, options) {
    let len = reader.uint32(), end = reader.pos + len, key, val;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case 1:
          key = reader.string();
          break;
        case 2:
          val = reader.string();
          break;
        default:
          throw new globalThis.Error("unknown map entry field for field infra.protocol.RespPack.metadata");
      }
    }
    map[key ?? ""] = val ?? "";
  }
  internalBinaryWrite(message, writer, options) {
    if (message.fullMethodName !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.fullMethodName);
    if (message.req !== 0)
      writer.tag(2, WireType.Varint).uint32(message.req);
    if (message.body.length)
      writer.tag(3, WireType.LengthDelimited).bytes(message.body);
    for (let k of globalThis.Object.keys(message.metadata))
      writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
    if (message.err !== 0)
      writer.tag(5, WireType.Varint).int32(message.err);
    if (message.errMsg !== "")
      writer.tag(6, WireType.LengthDelimited).string(message.errMsg);
    if (message.errReson !== "")
      writer.tag(7, WireType.LengthDelimited).string(message.errReson);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new RespPack$Type();
class PushPack$Type extends MessageType {
  constructor() {
    super("infra.protocol.PushPack", [
      {
        no: 1,
        name: "fullMethodName",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "body",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      },
      {
        no: 3,
        name: "roomId",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
  create(value) {
    const message = globalThis.Object.create(this.messagePrototype);
    message.fullMethodName = "";
    message.body = new Uint8Array(0);
    message.roomId = "";
    if (value !== void 0)
      reflectionMergePartial(this, message, value);
    return message;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target ?? this.create(), end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string fullMethodName */
        1:
          message.fullMethodName = reader.string();
          break;
        case /* bytes body */
        2:
          message.body = reader.bytes();
          break;
        case /* string roomId */
        3:
          message.roomId = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
      }
    }
    return message;
  }
  internalBinaryWrite(message, writer, options) {
    if (message.fullMethodName !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.fullMethodName);
    if (message.body.length)
      writer.tag(2, WireType.LengthDelimited).bytes(message.body);
    if (message.roomId !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.roomId);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
    return writer;
  }
}
new PushPack$Type();

var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
let req_ = 0;
const requestSeq = () => {
  req_++;
  return req_;
};
const rawHeaderLen = 16;
const packetOffset = 0;
const headerOffset = 4;
const verOffset = 6;
const opOffset = 8;
const seqOffset = 12;
function mergeArrayBuffer(ab1, ab2) {
  const u81 = new Uint8Array(ab1), u82 = new Uint8Array(ab2), res = new Uint8Array(ab1.byteLength + ab2.byteLength);
  res.set(u81, 0);
  res.set(u82, ab1.byteLength);
  return res.buffer;
}
var GrpcWsEvent = /* @__PURE__ */ ((GrpcWsEvent2) => {
  GrpcWsEvent2["OnAuth"] = "OnAuth";
  GrpcWsEvent2["OnClose"] = "OnClose";
  GrpcWsEvent2["OnError"] = "OnError";
  GrpcWsEvent2["OnOpen"] = "OnOpen";
  GrpcWsEvent2["ReceiveRoomId"] = "ReceiveRoomId";
  GrpcWsEvent2["Lag"] = "Lag";
  return GrpcWsEvent2;
})(GrpcWsEvent || {});
class GrpcWebSocketClient {
  constructor() {
    __publicField$2(this, "reqMap", {});
    __publicField$2(this, "pending", []);
    __publicField$2(this, "ws");
    __publicField$2(this, "isUserClose", false);
    __publicField$2(this, "retryTimes", 0);
    /** 监听器 集合 */
    __publicField$2(this, "listeners", {});
    __publicField$2(this, "reconnectHandler");
    __publicField$2(this, "recvAt", 0);
    //心跳超时时长
    __publicField$2(this, "heartbeatTimeout", 10 * 1e3);
    //超时检查间隔
    __publicField$2(this, "heartbeatInterval", 3 * 1e3);
    // 当前心跳 seq
    __publicField$2(this, "heartbeatSeq", 0);
    // 当前周期还未回包的心跳
    __publicField$2(this, "pendingHeartbeats", [Date.now(), Date.now(), Date.now()]);
    // 当前周期总时长
    __publicField$2(this, "heartbeatDelay", 0);
    __publicField$2(this, "heartbeatCheckHandle");
    __publicField$2(this, "heartbeatSendHandle");
    __publicField$2(this, "textEncoder", new TextEncoder());
    __publicField$2(this, "textDecoder", new TextDecoder());
    __publicField$2(this, "servicesMap", /* @__PURE__ */ new Map());
    __publicField$2(this, "options");
    __publicField$2(this, "hasAuth", false);
    __publicField$2(this, "authKey");
    __publicField$2(this, "eventEmitter", mitt());
    __publicField$2(this, "waitRoomIds", []);
    __publicField$2(this, "connectRoomIds", /* @__PURE__ */ new Set());
    this.options = {
      userID: -1,
      roomID: "1031",
      authToken: "",
      baseURL: "ws://nodeport.oa.com:31253/infra/comet",
      name: "GrpcWebSocketClient"
    };
    this.reqMap = {};
    this.pending = [];
    this.isUserClose = false;
    this.textEncoder = new TextEncoder();
    this.textDecoder = new TextDecoder();
    this.servicesMap = /* @__PURE__ */ new Map();
  }
  setHeartbeatDelay(value) {
    this.heartbeatDelay = value;
    this.eventEmitter.emit("Lag" /* Lag */, value);
  }
  init(options) {
    if (this.options.userID != options.userID) {
      if (this.ws) {
        this.close(true);
      }
    }
    this.options = options;
  }
  connect() {
    if (this.ws) {
      return;
    }
    this.hasAuth = false;
    this.isUserClose = false;
    const baseURL = this.options.baseURL;
    const WebSocket2 = window["WebSocket"];
    if (this.options.authToken && this.options.authToken != "") {
      this.ws = new WebSocket2(baseURL, this.options.authToken);
    } else {
      this.ws = new WebSocket2(baseURL);
    }
    this.ws.binaryType = "arraybuffer";
    this.ws.onmessage = (e) => {
      this.onWsMessage(e);
    };
    this.ws.onopen = () => {
      this.eventEmitter.emit("OnOpen" /* OnOpen */);
      this.clearRoom();
      this.onHeartbeat();
      this.auth();
    };
    const onClose = () => {
      this.ws = null;
      this.hasAuth = false;
      this.waitRoomIds = [...this.connectRoomIds];
      this.clear();
      this.tryReconnect();
      this.setHeartbeatDelay(999);
    };
    this.ws.onclose = () => {
      this.eventEmitter.emit("OnClose" /* OnClose */);
      onClose();
    };
    this.ws.onerror = () => {
      this.eventEmitter.emit("OnError" /* OnError */);
      onClose();
    };
    const wsClose = this.ws.close.bind(this.ws);
    this.ws.close = (...args) => {
      wsClose(...args);
    };
  }
  /**
   * 尝试重连
   * @returns
   */
  tryReconnect() {
    if (this.retryTimes > 5e3) {
      return;
    }
    if (this.isUserClose == true) {
      this.isUserClose = false;
      return;
    }
    this.retryTimes++;
    if (this.reconnectHandler) {
      clearTimeout(this.reconnectHandler);
    }
    this.reconnectHandler = setTimeout(() => {
      this.reconnectHandler = 0;
      this.connect();
    }, 2e3);
  }
  /**
   * 认证登录信息
   */
  auth() {
    this.hasAuth = false;
    const token = `{"mid":${this.options.userID}, "room_id":"${this.options.roomID}", "platform":"web", "accepts":[1000,1100]}`;
    const headerBuf = new ArrayBuffer(rawHeaderLen);
    const headerView = new DataView(headerBuf, 0);
    const bodyBuf = this.textEncoder.encode(token);
    headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength);
    headerView.setInt16(headerOffset, rawHeaderLen);
    headerView.setInt16(verOffset, 1);
    headerView.setInt32(opOffset, 7);
    headerView.setInt32(seqOffset, 1);
    this.ws?.send(mergeArrayBuffer(headerBuf, bodyBuf));
  }
  onHeartbeat() {
    this.clear();
    this.sendHeartbeat();
    this.heartbeatCheckHandle = setInterval(() => {
      this.checkAlive();
    }, this.heartbeatInterval);
    this.heartbeatSendHandle = setInterval(this.sendHeartbeat.bind(this), this.heartbeatInterval);
  }
  /**
   * 认证成功回调
   */
  onAuthSuccess(authKey) {
    this.eventEmitter.emit("OnAuth" /* OnAuth */);
    this.hasAuth = true;
    this.authKey = authKey;
    this.processPendingReq();
  }
  /**
   * 加入房间
   * @param roomID
   */
  joinRoom(roomID) {
    if (this.checkAuthConnected()) {
      this.sendRoom(roomID);
    } else {
      this.waitRoomIds.push(roomID);
    }
    return new Promise((resolve) => {
      if (this.connectRoomIds.has(roomID)) {
        resolve(roomID);
      } else {
        const callBack = (id) => {
          if (id === roomID) {
            resolve(id);
            this.eventEmitter.off("ReceiveRoomId" /* ReceiveRoomId */, callBack);
          }
        };
        this.eventEmitter.on("ReceiveRoomId" /* ReceiveRoomId */, callBack);
      }
    });
  }
  sendRoom(roomID) {
    if (!this.checkWs()) return;
    const headerBuf = new ArrayBuffer(rawHeaderLen);
    const headerView = new DataView(headerBuf, 0);
    const bodyBuf = this.textEncoder.encode(roomID);
    headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength);
    headerView.setInt16(headerOffset, rawHeaderLen);
    headerView.setInt16(verOffset, 1);
    headerView.setInt32(opOffset, 18);
    headerView.setInt32(seqOffset, 1);
    this.ws?.send(mergeArrayBuffer(headerBuf, bodyBuf));
  }
  /**
   * 离开房间
   * @param roomID
   */
  leaveRoom(roomID) {
    if (!this.checkWs()) return;
    const headerBuf = new ArrayBuffer(rawHeaderLen);
    const headerView = new DataView(headerBuf, 0);
    const bodyBuf = this.textEncoder.encode(roomID);
    headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength);
    headerView.setInt16(headerOffset, rawHeaderLen);
    headerView.setInt16(verOffset, 1);
    headerView.setInt32(opOffset, 20);
    headerView.setInt32(seqOffset, 1);
    this.ws?.send(mergeArrayBuffer(headerBuf, bodyBuf));
    this.deleteRoom(roomID);
  }
  deleteRoom(roomID) {
    this.connectRoomIds.delete(roomID);
  }
  clearRoom() {
    this.connectRoomIds.clear();
  }
  /**
   * 发送心跳
   */
  sendHeartbeat() {
    if (this.ws) {
      const headerBuf = new ArrayBuffer(rawHeaderLen);
      const headerView = new DataView(headerBuf, 0);
      headerView.setInt32(packetOffset, rawHeaderLen);
      headerView.setInt16(headerOffset, rawHeaderLen);
      headerView.setInt16(verOffset, 1);
      headerView.setInt32(opOffset, 2);
      headerView.setInt32(seqOffset, this.heartbeatSeq);
      this.ws.send(headerBuf);
      this.pendingHeartbeats[this.heartbeatSeq] = Date.now();
      this.heartbeatSeq = (this.heartbeatSeq + 1) % this.pendingHeartbeats.length;
    }
  }
  /**
   * 检查心跳,如果超时则关闭链接
   */
  checkAlive() {
    if (Date.now() - this.recvAt > this.heartbeatTimeout) {
      this.close();
      this.clear();
    }
  }
  /**
   * 关闭链接
   * @param isUserClose 是否是用户主动关闭
   */
  close(isUserClose = false) {
    this.hasAuth = false;
    this.isUserClose = isUserClose;
    this.retryTimes = 0;
    if (this.reconnectHandler) {
      clearTimeout(this.reconnectHandler);
    }
    const oldWs = this.ws;
    if (oldWs) {
      oldWs.onclose?.(new CloseEvent("call close"));
      oldWs.onclose = noop;
      try {
        oldWs.close();
      } catch (e) {
        console.info(e);
      }
    }
  }
  /** 接收 WebSocket 消息 */
  onWsMessage(event) {
    const data = event.data;
    const dataView = new DataView(data, 0);
    let packetLen = dataView.getInt32(packetOffset);
    const headerLen = dataView.getInt16(headerOffset);
    const ver = dataView.getInt16(verOffset);
    const op = dataView.getInt32(opOffset);
    const seq = dataView.getInt32(seqOffset);
    this.recvAt = Date.now();
    switch (op) {
      case 8:
        const authBody = AuthReply.fromBinary(new Uint8Array(data.slice(headerLen, packetLen)));
        switch (authBody.code) {
          case AuthReply_Code.OK:
            this.onAuthSuccess(authBody.authKey);
            break;
          // 权限校验不通过
          case AuthReply_Code.Unauthenticated:
            break;
          default:
            throw new Error(authBody.code);
        }
        break;
      case 3:
        if (this.pendingHeartbeats[seq]) {
          const heartbeatDelay = Date.now() - this.pendingHeartbeats[seq];
          this.setHeartbeatDelay(heartbeatDelay);
        }
        break;
      case 9:
        for (let offset = rawHeaderLen; offset < data.byteLength; offset += packetLen) {
          packetLen = dataView.getInt32(offset);
          const headerLen2 = dataView.getInt16(offset + headerOffset);
          const ver2 = dataView.getInt16(offset + verOffset);
          const op2 = dataView.getInt32(offset + opOffset);
          const msgBody = data.slice(offset + headerLen2, offset + packetLen);
          this.messageReceived(ver2, op2, msgBody);
        }
        break;
      case 23:
        const body = data.slice(headerLen, packetLen);
        const resp = GrpcCallReply.fromBinary(new Uint8Array(body));
        const req = resp.req;
        const reqInfo = this.reqMap[req];
        if (reqInfo) {
          reqInfo.cb?.(resp);
          delete this.reqMap[req];
        }
        break;
      default: {
        const msgBody = this.textDecoder.decode(data.slice(headerLen, packetLen));
        this.messageReceived(ver, op, msgBody);
        break;
      }
    }
  }
  messageReceived(_ver, op, body) {
    if (op === 1100) {
      const ret = PushReq.fromBinary(new Uint8Array(body));
      const services = ret.fullMethodName.split("/");
      this.dispatch(services[1], services[2], ret);
    }
    if (op === 1e3) {
      const ret = new Uint8Array(body);
      this.dispatch("broadcast", "onRecv", ret);
    }
    if (op === 19) {
      const roomId = body;
      if (!isNil(roomId)) {
        this.connectRoomIds.add(roomId);
        this.eventEmitter.emit("ReceiveRoomId" /* ReceiveRoomId */, roomId);
      }
    }
  }
  /**
   * 添加一个服务器推送监听
   * @param server 服务名。如: mpff.social.im.v2，如果传空，则会监听所有消息
   * @param listener
   */
  addEventListener(server, listener) {
    if (server == null || server === "") {
      server = "__ALL__";
    }
    let list = this.listeners[server];
    if (!list) {
      list = [];
      this.listeners[server] = list;
    }
    const index = list.indexOf(listener);
    if (index === -1) {
      list.push(listener);
    }
  }
  /** 移除监听器 */
  removeEventListener(listener) {
    for (const key in this.listeners) {
      const list = this.listeners[key];
      const index = list.indexOf(listener);
      if (index > -1) {
        list.splice(index, 1);
      }
    }
  }
  /**
   * 派发推送消息
   * @param server
   * @param method
   * @param pack
   */
  dispatch(server, method, pack) {
    let list = this.listeners.__ALL__;
    const body = this.decodeServiceMethod.bind(this, server, method, pack)();
    const event = {
      server,
      method,
      body,
      pack
    };
    if (list) {
      for (const listener of list) {
        listener(event);
      }
    }
    list = this.listeners[server];
    if (list) {
      for (const listener of list) {
        listener(event);
      }
    }
  }
  /**
   * 清理定时器
   */
  clear() {
    try {
      if (this.heartbeatCheckHandle) {
        clearInterval(this.heartbeatCheckHandle);
        this.heartbeatCheckHandle = 0;
      }
      if (this.heartbeatSendHandle) {
        clearInterval(this.heartbeatSendHandle);
        this.heartbeatSendHandle = 0;
      }
    } catch (ex) {
    }
  }
  // 注册服务
  registerService(service) {
    this.servicesMap.set(service.typeName, service);
  }
  // 解码推送服务数据
  decodeServiceMethod(server, method, pack) {
    const service = this.servicesMap.get(server);
    let content = null;
    if (service) {
      const methodInfo = service.methods.find((m) => m.name === method);
      if (methodInfo) {
        content = methodInfo.O.fromBinary(pack.body);
      }
    }
    return content;
  }
  checkWs() {
    return !!this.ws && this.ws.readyState === WebSocket.OPEN;
  }
  checkAuthConnected() {
    return this.hasAuth && this.checkWs();
  }
  callGRPC(fullMethodName, body, destID, meta, cb, roomId) {
    const callPack = GrpcCallReq.create({
      req: requestSeq(),
      fullMethodName,
      body,
      metadata: meta,
      destID
    });
    const reqInfo = {
      req: callPack.req,
      data: callPack,
      cb,
      timestamp: Date.now(),
      roomId
    };
    this.reqMap[callPack.req] = reqInfo;
    if (this.checkAuthConnected()) {
      this.sendPack(callPack, roomId);
    } else {
      this.pending.push(reqInfo);
    }
  }
  sendPack(callPack, roomId) {
    const onSend = () => {
      const bodyBuf = GrpcCallReq.toBinary(callPack);
      const headerBuf = new ArrayBuffer(rawHeaderLen);
      const headerView = new DataView(headerBuf, 0);
      headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength);
      headerView.setInt16(headerOffset, rawHeaderLen);
      headerView.setInt16(verOffset, 1);
      headerView.setInt32(opOffset, 22);
      headerView.setInt32(seqOffset, 1);
      this.ws?.send(mergeArrayBuffer(headerBuf, bodyBuf));
    };
    if (!isNil(roomId)) {
      if (!this.connectRoomIds.has(roomId)) {
        const callBack = (id) => {
          if (id === roomId) {
            onSend();
            this.eventEmitter.off("ReceiveRoomId" /* ReceiveRoomId */, callBack);
          }
        };
        this.eventEmitter.on("ReceiveRoomId" /* ReceiveRoomId */, callBack);
      }
    }
    onSend();
  }
  broadcast(bodyBuf) {
    const headerBuf = new ArrayBuffer(rawHeaderLen);
    const headerView = new DataView(headerBuf, 0);
    headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength);
    headerView.setInt16(headerOffset, rawHeaderLen);
    headerView.setInt16(verOffset, 1);
    headerView.setInt32(opOffset, 4);
    headerView.setInt32(seqOffset, 1);
    this.ws?.send(mergeArrayBuffer(headerBuf, bodyBuf));
  }
  processPendingReq() {
    this.waitRoomIds.forEach((roomId) => {
      this.sendRoom(roomId);
    });
    this.waitRoomIds = [];
    this.pending.forEach((info) => {
      this.sendPack(info.data, info.roomId);
    });
    this.pending = [];
  }
  isConnected() {
    return this.ws !== null;
  }
}
let rpcClientInstance;
function getGrpcWebSocketClient() {
  if (!rpcClientInstance) {
    rpcClientInstance = new GrpcWebSocketClient();
  }
  return rpcClientInstance;
}
let chatClientInstance;
function getChatClient() {
  if (!chatClientInstance) {
    chatClientInstance = new GrpcWebSocketClient();
  }
  return chatClientInstance;
}

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => __defNormalProp$1(obj, key + "" , value);
class WebSocketTransport {
  constructor(defaultOptions) {
    __publicField$1(this, "defaultOptions");
    this.defaultOptions = defaultOptions;
  }
  setOptions(defaultOptions) {
    this.defaultOptions = defaultOptions;
  }
  mergeOptions(options) {
    return mergeRpcOptions(this.defaultOptions, options);
  }
  /**
   * Create an URI for a gRPC web call.
   *
   * Takes the `baseUrl` option and appends:
   * - slash "/"
   * - package name
   * - dot "."
   * - service name
   * - slash "/"
   * - method name
   *
   * If the service was declared without a package, the package name and dot
   * are omitted.
   *
   * All names are used exactly like declared in .proto.
   */
  makeUrl(method, options) {
    let base = options.baseUrl;
    if (base?.endsWith("/")) base = base.substring(0, base.length - 1);
    return `${base}/${method.service.typeName}/${method.name}`;
  }
  clientStreaming(method) {
    const e = new RpcError(
      "Client streaming is not supported by grpc-web",
      GrpcStatusCode[GrpcStatusCode.UNIMPLEMENTED]
    );
    e.methodName = method.name;
    e.serviceName = method.service.typeName;
    throw e;
  }
  duplex(method) {
    const e = new RpcError(
      "Duplex streaming is not supported by grpc-web",
      GrpcStatusCode[GrpcStatusCode.UNIMPLEMENTED]
    );
    e.methodName = method.name;
    e.serviceName = method.service.typeName;
    throw e;
  }
  serverStreaming(_method, _input, _options) {
    const a = 1;
    return a;
  }
  unary(method, input, options) {
    let opt = options, inputBytes = method.I.toBinary(input, opt.binaryOptions), defHeader = new Deferred(), maybeMessage, defMessage = new Deferred(), maybeStatus, defStatus = new Deferred(), defTrailer = new Deferred();
    const destID = opt.destID || void 0;
    const broadcast = opt.broadcast || false;
    const fullMethodName = `/${method.service.typeName}/${method.name}`;
    if (broadcast == true) {
      if (!getChatClient().isConnected()) {
        getChatClient().connect();
      }
      getChatClient().broadcast(inputBytes);
      const ret = "";
      defHeader.resolve(ret);
      defMessage.resolve(ret);
      defStatus.resolve(ret);
      defTrailer.resolve(ret);
    } else {
      const grpcWebSocketClient = getGrpcWebSocketClient();
      if (!grpcWebSocketClient.isConnected()) {
        grpcWebSocketClient.connect();
      }
      grpcWebSocketClient.callGRPC(
        fullMethodName,
        inputBytes,
        destID,
        void 0,
        (resp) => {
          const code = resp.err;
          if (resp.err == 0) {
            maybeMessage = method.O.fromBinary(resp.body, opt.binaryOptions);
            maybeStatus = {
              code: GrpcStatusCode[code],
              detail: GrpcStatusCode[code]
            };
            defHeader.resolve(resp.metadata);
            defMessage.resolve(maybeMessage);
            defStatus.resolve(maybeStatus);
            defTrailer.resolve(resp.metadata);
          } else {
            let error;
            error = new RpcError(resp.errMsg, resp.err.toString(), resp.metadata);
            error.methodName = method.name;
            error.serviceName = method.service.typeName;
            defHeader.rejectPending(error);
            defMessage.rejectPending(error);
            defStatus.rejectPending(error);
            defTrailer.rejectPending(error);
          }
        },
        opt.roomId
      );
    }
    return new UnaryCall(
      method,
      opt.meta ?? {},
      input,
      defHeader.promise,
      defMessage.promise,
      defStatus.promise,
      defTrailer.promise
    );
  }
}

var EnvKey = /* @__PURE__ */ ((EnvKey2) => {
  EnvKey2["Development"] = "development";
  EnvKey2["Test"] = "test";
  EnvKey2["Production"] = "production";
  return EnvKey2;
})(EnvKey || {});
const development = {
  wss: "wss://api-dev.gawallet.org:30180/infra/comet",
  grpc: "https://api-dev.gawallet.org:30180",
  appid: 1031,
  token: "7fuvs9jdunnD6WQWrytP3WK0",
  chatWs: "wss://api-dev.gawallet.org:30180/infra/imgateway/comet",
  http: "http://api-dev.gawallet.org:30180"
};
const test = {
  wss: "wss://api-test.mtt.xyz/infra/comet",
  grpc: "https://api-test.mtt.xyz",
  appid: 1031,
  token: "7fuvs9jdunnD6WQWrytP3WK0",
  chatWs: "wss://api-test.mtt.xyz/infra/imgateway/comet",
  http: "https://api-test.mtt.xyz"
};
const production = {
  wss: "wss://api.gawallet.org/infra/comet",
  grpc: "https://api.mtt.xyz",
  appid: 3057,
  token: "5HBC5NVkLjuOoyCHtvAwPzVe",
  chatWs: "wss://api.gawallet.org/infra/imgateway/comet",
  http: "https://api.mtt.xyz"
};
const configs = {
  ["development" /* Development */]: { ...development },
  ["test" /* Test */]: { ...test },
  ["production" /* Production */]: { ...production }
};

function safeParse(str, fallback) {
  if (!str) {
    return fallback;
  }
  try {
    return JSON.parse(str || "");
  } catch (error) {
    console.debug(`[safeParse] fallback`, fallback);
    return fallback;
  }
}
function getLoginKeyInfo(key = "LoginKey" /* LoginKey */) {
  if (typeof localStorage === "undefined") {
    return void 0;
  }
  return safeParse(localStorage.getItem(key));
}
function DEAFULT_GET_MTT_TOKEN() {
  return getLoginKeyInfo()?.respCommon?.token;
}

const INNER_STATE = {};
function setMttTokenGetter(getMttToken) {
  INNER_STATE.getMttToken = getMttToken;
}
function setGrpcEnv(env) {
  INNER_STATE.env = env;
  if (env) {
    reInitLogger(isDev, getIsProd());
  }
}
function initTokenGetterForBrowser() {
  if (typeof localStorage !== "undefined") {
    if (isDev) {
      console.info("%c@mtt/grpc-core%c default tokenGetter settled, customize via setMttTokenGetter(fn) if needed", "background:#1890ff;color:#ffffff;border-radius:3px;padding:1px 5px;", "background:#111827;color:#1890ff;border-radius:3px;padding:1px 5px;");
    }
    setMttTokenGetter(DEAFULT_GET_MTT_TOKEN);
  }
}
function getMttTokenGetter() {
  if (!INNER_STATE.getMttToken) {
    initTokenGetterForBrowser();
    if (isDev && !INNER_STATE.getMttToken) {
      console.info("%c@mtt/grpc-core%c if needed, token getter can be set via setMttTokenGetter", "background:#1890ff;color:#ffffff;border-radius:3px;padding:1px 5px;", "background:#111827;color:#1890ff;border-radius:3px;padding:1px 5px;");
    }
  }
  return INNER_STATE.getMttToken;
}
function getGrpcEnv() {
  if (!INNER_STATE.env) {
    console.info("%c@mtt/grpc-core%c env is not set, please set it by setGrpcEnv ", "background:#1890ff;color:#ffffff;border-radius:3px;padding:1px 5px;", "background:#111827;color:#1890ff;border-radius:3px;padding:1px 5px;");
    throw new Error("Please set env for @mtt/grpc-core");
  }
  return INNER_STATE.env;
}
const isDev = process.env.NODE_ENV === "development";
const getIsProd = () => getGrpcEnv() === EnvKey.Production;
const getConfig = (_env) => {
  if (INNER_STATE.config) {
    return INNER_STATE.config;
  }
  const env = _env || getGrpcEnv();
  const value = configs[env];
  return { ...value, env };
};
function setConfig(setter) {
  INNER_STATE.config = setter(configs, INNER_STATE.env);
}

const createAuthTransport = () => {
  return new GrpcWebFetchTransport({
    format: "binary",
    getBaseUrl() {
      return getConfig().grpc;
    },
    meta: {
      ...INNER_STATE.meta,
      get Authorization() {
        const token = getMttTokenGetter()?.();
        return token || "";
      }
    }
  });
};
const createNoAuthTransport = () => {
  return new GrpcWebFetchTransport({
    format: "binary",
    getBaseUrl() {
      return getConfig().grpc;
    }
  });
};

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class GrpcServiceMgr {
  constructor(ClientClass, createAuth = createAuthTransport, grpcWebOptions) {
    __publicField(this, "_ClientClass");
    __publicField(this, "_creator");
    __publicField(this, "_transport");
    __publicField(this, "_client");
    __publicField(this, "_grpcWebOptions");
    this._ClientClass = ClientClass;
    this._creator = createAuth;
    this._grpcWebOptions = grpcWebOptions;
    const transport = createAuth(grpcWebOptions);
    this._transport = transport;
    this._client = new ClientClass(transport);
  }
  _reInit() {
    const transport = this._creator(this._grpcWebOptions);
    this._transport = transport;
    this._client = new this._ClientClass(transport);
  }
  _getTransPort() {
    return this._transport;
  }
  /** 开头要有 /, 结尾不要有 /, 中间的 url http://[baseUrl][baseUrlAddon]/... */
  _setBaseUrlAddon(addon) {
    this._transport.setOptions({ baseUrlAddon: addon || "" });
  }
}

const authTransport = createNoAuthTransport();
const authGawTransport = authTransport;
const webSocketTransport = new WebSocketTransport({
  format: "binary",
  baseUrl: ""
});
const createNoAuthHub = () => {
  return new GrpcWebFetchTransport({
    format: "binary",
    getBaseUrl() {
      return `${getConfig().grpc}/matchhub_noauth/`;
    }
  });
};
const createNoAuthUser = () => {
  return new GrpcWebFetchTransport({
    format: "binary",
    getBaseUrl() {
      return `${getConfig().grpc}/mttuser/`;
    }
  });
};
const createAuthUser = () => {
  return new GrpcWebFetchTransport({
    format: "binary",
    getBaseUrl() {
      return `${getConfig().grpc}/grpc/user/`;
    }
  });
};

export { EnvKey, GRPCError, GrpcServiceMgr, GrpcStatusCode, GrpcWebFetchTransport, GrpcWebFrame, GrpcWebSocketClient, GrpcWsEvent, INNER_STATE, WebSocketTransport, authGawTransport, authTransport, configs, createAuthTransport, createAuthUser, createGrpcWebRequestBody, createGrpcWebRequestHeader, createNoAuthHub, createNoAuthTransport, createNoAuthUser, getChatClient, getConfig, getGrpcEnv, getGrpcWebSocketClient, getLoginKeyInfo, readGrpcWebResponseBody, readGrpcWebResponseHeader, readGrpcWebResponseTrailer, setConfig, setGrpcEnv, setMttTokenGetter, webSocketTransport };
